// extracted by mini-css-extract-plugin
export default {"empty":"empty--LAj_R","noTagsMessage":"noTagsMessage--EpnMp","text":"text--hbcD9","color":"color--eaJk5","editButton":"editButton--jKbxf"};